// extracted by mini-css-extract-plugin
export default {"slideshowControls":"slideshowControls_slideshowControls__vcMRq","obsolete":"slideshowControls_obsolete__Ay-A4","controlsSection":"slideshowControls_controlsSection__jlXF2"};